module.exports = __webpack_public_path__ + "img/right.50a9bdfc.png";